import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

const initialState = {
  user: null,
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem('token'),
  tokenExpired: false,
  showTokenExpiredDialog: false,
};

export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      // Using our API service instead of direct axios
      const response = await api.post('/users/login', credentials);
      localStorage.setItem('token', response.data.token);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Đăng nhập thất bại' });
    }
  }
);

export const logout = createAsyncThunk('auth/logout', async () => {
  localStorage.removeItem('token');
  return null;
});

// Thunk để xử lý token hết hạn
export const handleTokenExpired = createAsyncThunk(
  'auth/handleTokenExpired',
  async (_, { dispatch }) => {
    localStorage.removeItem('token');
    // Hiển thị popup thông báo
    dispatch(showTokenExpiredDialog());
    return null;
  }
);

export const fetchUserProfile = createAsyncThunk(
  'auth/fetchUserProfile',
  async (_, { rejectWithValue }) => {
    try {
      // Using our API service which already handles the authorization header
      const response = await api.get('/users/me');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Lỗi khi lấy thông tin người dùng' });
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    },
    showTokenExpiredDialog: (state) => {
      state.showTokenExpiredDialog = true;
      state.tokenExpired = true;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
    },
    hideTokenExpiredDialog: (state) => {
      state.showTokenExpiredDialog = false;
    },
    resetTokenExpired: (state) => {
      state.tokenExpired = false;
      state.showTokenExpiredDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.user = action.payload.user;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.tokenExpired = false;
        state.showTokenExpiredDialog = false;
      })
      .addCase(handleTokenExpired.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.tokenExpired = true;
        state.showTokenExpiredDialog = true;
      })
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearErrors, showTokenExpiredDialog, hideTokenExpiredDialog, resetTokenExpired } = authSlice.actions;
export default authSlice.reducer;